import BaseDropdownInputView from '../base';

export default class DropdownInputBooleanView extends BaseDropdownInputView {
  classNameIdentifier = 'custom-dropdown-boolean-renderer';
}
